import * as React from 'react';

function NavUI(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 128 128"
            {...props}
        >
            <path
                d="M50.42,92.07H79.08A5.09,5.09,0,0,0,84.18,87V53.22h13.6a5.1,5.1,0,0,0,3.61-8.7l-33-33a5.09,5.09,0,0,0-7.2,0l-33,33a5.1,5.1,0,0,0,3.6,8.7h13.6V87A5.09,5.09,0,0,0,50.42,92.07ZM25.91,105h77.67a6.49,6.49,0,0,1,6.49,6.49h0a6.49,6.49,0,0,1-6.49,6.49H25.91a6.49,6.49,0,0,1-6.49-6.49h0A6.49,6.49,0,0,1,25.91,105Z"
                fill="currentColor"
            />
        </svg>
    );
}

export default NavUI;
